import { useTranslation } from "@redotech/redo-i18n";
import type { LocationNameState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const LocationNameDetails = memo(function LocationNameDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<LocationNameState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  return (
    <Flex dir="column" gap="md">
      <RedoTagInputField
        delimiters={["newline"]}
        description={t("Press enter to add a location name (case sensitive)")}
        inputValue={inputValue}
        label={t("Origin location names")}
        placeholder={t("Type location name and press enter")}
        setInputValue={setInputValue}
        setTags={(names) => setState({ names })}
        state={disabled ? "disabled" : "default"}
        tags={state.names.map((name) => ({ text: name, color: "gray" }))}
      />
    </Flex>
  );
});
